export default "__VITE_ASSET__aa6ee92f__"